export default __webpack_public_path__ + "static/media/synthetic-verbatim.7278b5b8.gif";